import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ul",
  "ol",
  "li",
  "a",
];

const DEFAULT_TITLE_KEY = "components.notifications.default_title";

export function getNotificationDisplayTitle(notification, translate = (value) => value) {
  const title = notification?.title?.trim() || DEFAULT_TITLE_KEY;
  return translate(title);
}

export function sanitizeNotificationHtml(content) {
  if (!content) return "";

  const sanitized = DOMPurify.sanitize(content, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "title"],
    ALLOW_DATA_ATTR: false,
  });

  if (typeof DOMParser === "undefined") return sanitized;

  const document = new DOMParser().parseFromString(sanitized, "text/html");
  document.querySelectorAll("a").forEach((anchor) => {
    const href = anchor.getAttribute("href");
    if (!href || !/^(https?:|mailto:)/i.test(href.trim())) {
      anchor.removeAttribute("href");
      return;
    }

    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");
  });

  return document.body.innerHTML;
}

export function getNotificationPlainText(
  notification,
  translate = (value) => value,
) {
  const content = notification?.body || notification?.htmlBody || "";
  if (!content) return "";

  const sanitized = sanitizeNotificationHtml(translate(content));
  if (typeof DOMParser === "undefined") {
    return sanitized.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  const document = new DOMParser().parseFromString(sanitized, "text/html");
  return (document.body.textContent || "").replace(/\s+/g, " ").trim();
}
